<!-- =========================================================================================
  File Name: ManagePlugins.vue
  Description: Manage Plugins Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.upload-files span {
  padding: 9px 13px;
  background: #4c8af6;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
}
</style>
<template>
  <div id="page-user-list">
    <div class="header-custome">
      <h3>Manage Plugins</h3>
    </div>

    <div class="vx-row pt-5">
      <div
        class="vx-col w-full md:w-1/3 sm:w-1/2 mb-base mt-5"
        v-for="item in filteredKB"
        :key="item.id"
      >
        <vx-card
          class="text-center cursor-pointer"
          style="width: 70%; height: 100%"
        >
          <h4 class="mb-2">{{ item.title.toUpperCase() }}</h4>
          <small>{{ item.description }}</small>
          <br />
          <br />
          <vs-button
            color="primary"
            type="filled"
            @click="openPluginModalByType(item.id)"
            >Setup</vs-button
          >
        </vx-card>
      </div>
    </div>

    <vs-popup
      class="holamundo"
      title="Add/Update Plugin"
      :active.sync="popupActiveAddTopic"
    >
      <div class="vx-col w-full text-right"></div>
      <div class="w-full group-creation-wrapper">
        <div v-if="oneToOneChatFlg">
          <label>Enable / Disable Chat</label>
          <vs-switch v-model="chatFlag" />
          <label class="mr-5">Send Default Message</label>
          <vs-textarea
            name="defaultmsg"
            v-model="defaultChatMsg"
            v-validate="'required'"
            data-vv-as="Default Message"
          />
          <span v-show="errors.has('defaultmsg')" class="text-danger">{{
            errors.first("defaultmsg")
          }}</span>
        </div>
        <!-- <div v-if="!toggleFlg && !helpDeskToggleFlg && !socialWallToggleFlag && !oneToOneChatFlg">
          <label>Api key</label>
          <vs-input
            name="apikey"
            class="inputx input-track-name w-full mb-3"
            v-model="apiKey"
            v-validate="'required'"
            data-vv-as="Api Key"
          />
          <span v-show="errors.has('apikey')" class="text-danger">{{
            errors.first("apikey")
          }}</span>
        </div> -->

        <div
          v-if="helpDeskToggleFlg && !oneToOneChatFlg && !socialWallToggleFlag"
        >
          <!-- <label class="mr-5">Embeded Code</label>
          <vs-textarea
            name="embededcode"
            v-model="embededCode"
            v-validate="'required'"
            data-vv-as="Embeded Code"
          /> -->
          <!-- <span v-show="errors.has('embededcode')" class="text-danger">{{
            errors.first("embededcode")
          }}</span> -->
        </div>
        <div v-if="!helpDeskToggleFlg && !oneToOneChatFlg">
          <vs-radio
            v-model="enableDisableFlg"
            vs-value="Enable"
            vs-name="navbar-type-sticky"
            class="mr-3"
            >Enable</vs-radio
          >
          <vs-radio
            v-model="enableDisableFlg"
            vs-value="Disable"
            vs-name="navbar-type-floating"
            >Disable</vs-radio
          >
        </div>
        <div v-if="helpDeskToggleFlg && !oneToOneChatFlg">
          <label
            >Info Page Background Image
            <b
              ><small>
                (The dimension of the image should be 1616px X 635px)
              </small></b
            ></label
          >
          <div class="mt-2 bg-img-path mb-4">
            <!--<vs-input class="inputx w-full" name="bgImagePath" v-model="data_local.coundownLobby.bgImagePath" v-validate="'required'"/>-->
            <vs-input
              class="inputx w-full"
              name="bgImagePath"
              v-model="previewImage"
              v-validate="'required'"
            />
            <label class="upload-files">
              <input
                type="file"
                ref="lobbyBgUpload_input"
                @change="infoDeskImageUpload($event, 'bgImagePath', 'imgSrc')"
                accept="image/*"
              />
            </label>
            <span
              class="text-danger text-sm"
              v-show="errors.has('bgImagePath')"
              >{{ errors.first("bgImagePath") }}</span
            >
            <br />
            <a style="float: right" @click="ResetToDefault"
              >Reset to Default Image</a
            >
            <div>
              <br />
              <label>Preview</label>
              <br />
              <img
                :src="imgSrc"
                style="height: 200px; width: 400px; margin-left: 10%"
              />
            </div>
            <br />
            <div>
              <label style="margin-right: 5px">
                <feather-icon
                  class="ml-2 info-ico-i"
                  icon="InfoIcon"
                  title="Please ensure to activate the 'Help Chat' plugin before enabling this feature"
                />
                Show Live Help Chat Panel</label
              >
              <vs-radio
                v-model="enableDisableHelpChatFlg"
                vs-value="Enable"
                vs-name="navbar-type-sticky"
                class="mr-3"
                >Enable</vs-radio
              >
              <vs-radio
                v-model="enableDisableHelpChatFlg"
                vs-value="Disable"
                vs-name="navbar-type-floating"
                >Disable</vs-radio
              >
            </div>
          </div>
        </div>
      </div>
      <div align="right">
        <vs-button color="rgb(76, 139, 246)" type="filled" @click="addOrUpdatePlugin">Add</vs-button>
      </div>
      <!-- </div> -->
    </vs-popup>
  </div>
</template>
<script>
var vm;
import moduleEventManagement from "@/store/event-management/moduleEventManagement.js";
import ls from "@/common/localStorage";
import TheFooterVue from "../../layouts/components/TheFooter.vue";
var cn = ls.getSessionEventCollectionName();
var vm;
export default {
  data() {
    return {
      knowledgeBaseSearchQuery: "",
      kb: [
        {
          id: 1,
          title: "Help Chat",
          description: "Please Provide the values to use Help Chat",
        },
        {
          id: 2,
          title: "Social Wall",
          description: "Please Provide the values to use Social Wall",
        },
        {
          id: 3,
          title: "Info Desk",
          description: "Please Provide the values to use Info Desk",
        },
        {
          id: 4,
          title: "One to One Chat",
          description: "Please Provide the values to use One to One Chat",
        },
      ],
      popupActiveAddTopic: false,
      data_local: {},
      toggleFlg: false,
      embededCode: null,
      enableDisableFlg: "Disable",
      apiKey: null,
      helpDeskToggleFlg: false,
      imgSrc: null,
      previewImage: "",
      enableDisableHelpChatFlg: "Disable",
      oneToOneChatFlg: false,
      chatFlag: false,
      defaultChatMsg: "Hi 👋",
      socialWallToggleFlag: false,
    };
  },
  watch: {},
  computed: {
    filteredKB() {
      return this.kb.filter((item) =>
        item.title
          .toLowerCase()
          .includes(this.knowledgeBaseSearchQuery.toLowerCase())
      );
    },
  },
  methods: {
    openPluginModalByType(id) {
      this.fetch_event_data(id);
    },
    addOrUpdatePlugin() {
      this.data_local.embededCode = this.embededCode;
      this.data_local.enableDisableFlg = this.enableDisableFlg;
      this.data_local.apiKey = this.apiKey;
      this.data_local.InfoPageBackgroundImage = this.previewImage;
      this.data_local.InfoPageShowLiveHelpChatPanel = this.enableDisableHelpChatFlg;
      this.data_local.OneToOneChat = this.chatFlag;
      this.data_local.defaultChatMsg = this.defaultChatMsg;
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading();
          this.$store
            .dispatch("eventManagement/addUpdatePlugin", {
              data: this.data_local,
            })
            .then((res) => {
              if (res.status == 200) {
                this.$vs.notify({
                  position: "top-center",
                  color: "success",
                  title: "Plugin Added/Updated",
                  text: res.message,
                });
              }
              this.popupActiveAddTopic = false;
              this.data_local = [];
              this.$vs.loading.close();
            })
            .catch((err) => {
              console.log(err);
            });
          this.$vs.loading.close();
        }
      });
    },
    fetch_event_data(type) {
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      this.$store
        .dispatch("eventManagement/fetchEvent", Session_Event_Id)
        .then((res) => {
          if (res.data.Plugins != undefined) {
            if (type == 1) {
              if (res.data.Plugins.HelpChat != undefined) {
                this.data_local.enableDisableFlg =
                  res.data.Plugins.HelpChat.isEnabled == true
                    ? "Enable"
                    : "Disable";
                this.enableDisableFlg = this.data_local.enableDisableFlg;

                this.data_local.apiKey = res.data.Plugins.HelpChat.ApiKey;
                this.embededCode = res.data.Plugins.HelpChat.EmbedCode;
                this.toggleFlg = false;
                this.popupActiveAddTopic = true;
                this.imgSrc = null;
                this.previewImage = null;
                this.helpDeskToggleFlg = false;
                this.oneToOneChatFlg = false;
                this.socialWallToggleFlag = false;
              } else {
                this.data_local = [];
                this.toggleFlg = false;
                (this.embededCode = null),
                  (this.enableDisableFlg = "Disable"),
                  (this.apiKey = null);
                this.popupActiveAddTopic = true;
                this.imgSrc = null;
                this.previewImage = null;
                this.helpDeskToggleFlg = false;
                this.oneToOneChatFlg = false;
                this.socialWallToggleFlag = false;
              }
            } else if (type == 2) {
              if (res.data.Plugins.SocialWall != undefined) {
                this.embededCode = res.data.Plugins.SocialWall.EmbedCode;
                this.data_local.enableDisableFlg =
                  res.data.Plugins.SocialWall.isEnabled == true
                    ? "Enable"
                    : "Disable";
                this.toggleFlg = true;
                this.popupActiveAddTopic = true;
                this.imgSrc = null;
                this.previewImage = null;
                this.helpDeskToggleFlg = false;
                this.oneToOneChatFlg = false;
                this.socialWallToggleFlag = true;
              } else {
                this.data_local = [];
                this.toggleFlg = true;
                (this.embededCode = null),
                  (this.enableDisableFlg = "Disable"),
                  (this.apiKey = null);
                this.popupActiveAddTopic = true;
                this.imgSrc = null;
                this.previewImage = null;
                this.helpDeskToggleFlg = false;
                this.oneToOneChatFlg = false;
                this.socialWallToggleFlag = true;
              }
            } else if (type == 3) {
              if (res.data.Plugins.InfoDesk != undefined) {
                this.enableDisableHelpChatFlg =
                  res.data.Plugins.InfoDesk.InfoPageShowLiveHelpChatPanel ==
                  true
                    ? "Enable"
                    : "Disable";
                this.previewImage =
                  res.data.Plugins.InfoDesk.InfoPageBackgroundImage == ""
                    ? "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Fhelpdesk-bg.jpg?alt=media"
                    : res.data.Plugins.InfoDesk.InfoPageBackgroundImage;
                this.imgSrc =
                  res.data.Plugins.InfoDesk.InfoPageBackgroundImage == ""
                    ? "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Fhelpdesk-bg.jpg?alt=media"
                    : res.data.Plugins.InfoDesk.InfoPageBackgroundImage;
                this.helpDeskToggleFlg = true;
                this.popupActiveAddTopic = true;
                this.oneToOneChatFlg = false;
                this.socialWallToggleFlag = false;
              } else {
                this.data_local = [];
                this.previewImage =
                  "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Fhelpdesk-bg.jpg?alt=media";
                this.imgSrc =
                  "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Fhelpdesk-bg.jpg?alt=media";
                this.toggleFlg = false;
                (this.embededCode = null),
                  (this.enableDisableFlg = "Disable"),
                  (this.apiKey = null);
                this.popupActiveAddTopic = true;
                this.helpDeskToggleFlg = true;
                this.enableDisableHelpChatFlg = "Disable";
                this.oneToOneChatFlg = false;
                this.socialWallToggleFlag = false;
              }
            } else if (type == 4) {
              if (res.data.Plugins.OneToOneChat != undefined) {
                this.previewImage = null;
                this.imgSrc = null;
                this.oneToOneChatFlg = true;
                this.helpDeskToggleFlg = false;
                this.popupActiveAddTopic = true;
                this.chatFlag = res.data.Plugins.OneToOneChat.IsEnabled;
                this.defaultChatMsg =
                  res.data.Plugins.OneToOneChat.defaultChatMsg;
                this.socialWallToggleFlag = false;
              } else {
                this.data_local = [];
                this.previewImage =
                  "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Fhelpdesk-bg.jpg?alt=media";
                this.imgSrc =
                  "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Fhelpdesk-bg.jpg?alt=media";
                this.toggleFlg = false;
                (this.embededCode = null),
                  (this.enableDisableFlg = "Disable"),
                  (this.apiKey = null);
                this.popupActiveAddTopic = true;
                this.oneToOneChatFlg = true;
                this.helpDeskToggleFlg = false;
                this.enableDisableHelpChatFlg = "Disable";
                this.socialWallToggleFlag = false;
              }
            }
          } else {
            if (type == 1) {
              this.data_local = [];
              this.toggleFlg = false;
              (this.embededCode = null),
                (this.enableDisableFlg = "Disable"),
                (this.apiKey = null);
              this.popupActiveAddTopic = true;
              this.helpDeskToggleFlg = false;
              this.oneToOneChatFlg = false;
              this.socialWallToggleFlag = false;
            } else if (type == 2) {
              this.data_local = [];
              this.toggleFlg = true;
              (this.embededCode = null),
                (this.enableDisableFlg = "Disable"),
                (this.apiKey = null);
              this.popupActiveAddTopic = true;
              this.helpDeskToggleFlg = false;
              this.oneToOneChatFlg = false;
              this.socialWallToggleFlag = true;
            } else if (type == 3) {
              this.data_local = [];
              this.toggleFlg = false;
              (this.embededCode = null),
                (this.enableDisableFlg = "Disable"),
                (this.apiKey = null);
              this.popupActiveAddTopic = true;
              this.helpDeskToggleFlg = true;
              this.oneToOneChatFlg = false;
              this.socialWallToggleFlag = false;
            } else if (type == 4) {
              this.data_local = [];
              this.toggleFlg = false;
              (this.embededCode = null),
                (this.enableDisableFlg = "Disable"),
                (this.apiKey = null);
              this.oneToOneChatFlg = true;
              this.popupActiveAddTopic = true;
              this.helpDeskToggleFlg = false;
              this.socialWallToggleFlag = false;
            }
          }
        });
    },
    infoDeskImageUpload(input, fieldName, fieldsrc) {
      if (input.target.files && input.target.files[0]) {
        const bgImgfile = input.target.files[0];
        const metadata = { contentType: bgImgfile.type };
        const validImageTypes = ["image/jpeg", "image/png"];
        if (!validImageTypes.includes(bgImgfile.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let FileSize = bgImgfile.size / 1024 / 1024;
        if (FileSize > 1) {
          alert("Uploaded file size exceeds 1 MB");
          return false;
        }
        //this.data_local[fieldName] = bgImgfile;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.uploadFile(bgImgfile, fieldName, fieldsrc);
          this[fieldsrc] = e.target.result;
        };

        reader.readAsDataURL(input.target.files[0]);
      }
    },
    uploadFile(file, fieldName, fieldsrc) {
      this.$vs.loading();
      this.$store
        .dispatch("eventManagement/uploadImage", {
          file: file,
          path: cn + "/Info/",
        })
        .then((res) => {
          this.previewImage = res;
          this.$vs.loading.close();
        })
        .catch((err) => {
          //console.error(err)
          this.$vs.loading.close();
        });
    },
    ResetToDefault() {
      this.data_local.embededCode = this.embededCode;
      this.data_local.enableDisableFlg = this.enableDisableFlg;
      this.data_local.apiKey = this.apiKey;
      this.data_local.InfoPageBackgroundImage =
        "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Fhelpdesk-bg.jpg?alt=media";
      this.data_local.InfoPageShowLiveHelpChatPanel = this.enableDisableHelpChatFlg;
      this.$vs.loading();
      this.$store
        .dispatch("eventManagement/addUpdatePlugin", {
          data: this.data_local,
        })
        .then((res) => {
          if (res.status == 200) {
            this.$vs.notify({
              position: "top-center",
              color: "success",
              title: "Plugin Added/Updated",
              text: res.message,
            });
          }
          this.popupActiveAddTopic = false;
          this.data_local = [];
          this.$vs.loading.close();
        })
        .catch((err) => {
          console.log(err);
        });
      this.$vs.loading.close();
    },
  },
  mounted() {},
  created() {
    if (!moduleEventManagement.isRegistered) {
      this.$store.registerModule("eventManagement", moduleEventManagement);
      moduleEventManagement.isRegistered = true;
    }
  },
};
</script>

